export const environment = {
  production: false,
  environmentName: "@@{environmentName}@@",
  baseURL: "@@{baseURL}@@",
  vanityUrl: "@@{vtURL}@@",
  auth: {
    authority: 'https://login.microsoftonline.com/@@{tenantId}@@/v2.0',
    client_id: "@@{clientId}@@",
    redirect_uri: '/auth',
    domain_hint: "@@{domainHint}@@",
  }
};
